import angular from 'angular';
import {ChangesHistory} from './changes-history/changes-history.component';
import {ManageStudent} from './manage-student/manage-student.component';
import {PrintAllRegistrations} from './print-all-registrations/print-all-registrations.component';
import {PinRegistration} from './pin-registration/pin-registration.component';
import {PinValidation} from './pin-registration/pin-validation.component';
import {AddOutsidePersonByPin} from './pin-registration/add-outside-person.component';
import {AddOutsidePersonSummary} from './pin-registration/add-outside-person-summary.component';
import {AddOutsidePerson} from './manage-student/add-outside-person/add-outside-person.component';
import {EditOutsidePerson} from './manage-student/edit-outside-person/edit-outside-person.component';
import ManageStudentDialogController from './manage-student/manage-student-dialog.controller';
import StudentLeaveInfoController from './student-leave-info/student-leave-info.controller';
import ChangesHistoryDialogController from './changes-history/changes-history-dialog.controller';

/**
 * @desc  Module initialize.
 *
 * @ngInject
 */
export default angular
  .module('app.components', [])
  .component('changesHistoryComponent', ChangesHistory)
  .component('manageStudentComponent', ManageStudent)
  .component('printAllRegistrations', PrintAllRegistrations)
  .component('pinRegistration', PinRegistration)
  .component('pinValidation', PinValidation)
  .component('addOutsidePersonByPin', AddOutsidePersonByPin)
  .component('addOutsidePersonSummary', AddOutsidePersonSummary)
  .component('addOutsidePerson', AddOutsidePerson)
  .component('editOutsidePerson', EditOutsidePerson)
  .controller('ManageStudentDialogController', ManageStudentDialogController)
  .controller('StudentLeaveInfoController', StudentLeaveInfoController)
  .controller('ChangesHistoryDialogController', ChangesHistoryDialogController)
  .name;
